export default __webpack_public_path__ + "static/media/bnr2.203dc69d.jpg";